export enum UploadItemStatus {
  Pending = "Pending",
  Processing = "Processing",
  /** The worker accepted a background indexing run; the files view polls it. */
  Indexing = "Indexing",
  Indexed = "Indexed",
  IndexingFailed = "IndexingFailed",
  Completed = "Completed",
  Failed = "Failed",
}

export enum UploadItemType {
  PDF = "PDF",
  DOCX = "DOCX",
  DOC = "DOC",
  XLS = "XLS",
  XLSX = "XLSX",
  XLSM = "XLSM",
  UNKNOWN = "UNKNOWN",
  FOLDER = "FOLDER",
}

export enum UploadSource {
  LOCAL = "Local",
  ONEDRIVE = "OneDrive",
  SHAREPOINT = "SharePoint",
}

export type UploadItem = {
  id: string;
  name: string;
  type: UploadItemType;
  status: UploadItemStatus;
  hasFeedback?: boolean;
  feedback?: Record<string, string>;
  feedbackSeen?: boolean;
  source: UploadSource;
  driveId?: string;
  siteId?: string;
  sharepointFileId?: string;
  hasIndexingError?: boolean;
  /**
   * Upload finished with indexing still running in the background (LAR-412).
   * The document row in the files view carries the live spinner; the panel
   * only says so.
   */
  indexingInBackground?: boolean;
};
